<template>
  <div>
    <p class="cm-mg-p-wzd">
      2.1 {{ $t('fertilization.fertilizers_budgeted_card_info') }}
    </p>
    <hr />
    <br />
    <template>
      <div class="custom-table-responsive table-responsive">
        <table
          class="table table-striped table-bordered table table-journals not-last-td"
        >
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('fertilization.fertilizer') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('production.bundle_quantity') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('production.bundle_quantity_hectare') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index_num in fertilizer_len" :key="index_num">
              <td class="text-center" style="min-width: 250px">
                <el-select
                  style="width: 70%; margin: auto"
                  clearable
                  filterable
                  class="select-primary custom-width-select required shadow-sm fer-add required-second-step"
                  size="large"
                  v-model="model.fertilizers[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="addFactor(index_num - 1)"
                >
                  <el-option
                    v-for="option in availableFertilizers"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 200px">
                <el-input
                  style="width: 50%"
                  clearable
                  class="required-second-step text-center"
                  type="number"
                  min="0"
                  v-model="model.packages[index_num - 1]"
                />
              </td>
              <td class="text-center" style="min-width: 200px">
                <span v-if="model.packages[index_num - 1] && num_hectares">
                  {{
                    formatNumber(model.packages[index_num - 1] / num_hectares)
                  }}
                </span>
                <span v-else>0</span>
              </td>
              <td class="text-center vertical-custom" style="min-width: 100px">
                <div class="d-flex justify-content-center mt-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="fertilizer_len++"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="fertilizer_len > 1"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="handleDelete(index_num - 1)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-show="errorAlert">
        <div class="col-lg-12">
          <br />
          <el-alert
            ref="error_alert"
            :title="$t('common_words.errors')"
            type="error"
            >{{ error }}</el-alert
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        fertilizers: [],
        packages: [],
        fertilization_application_details_ids: [],
        fertilization_application_details_ids_bck: [],
      },
      fertilizer_len: 1,
      all_fertilizers: [],
      all_fertilizers_bck: [],
      fertilizers_bck_ids: [],
      num_hectares: 1,
    };
  },

  computed: {
    availableFertilizers() {
      return this.all_fertilizers.filter(
        (fertilizer) => !this.model.fertilizers.includes(fertilizer.id)
      );
    },
  },

  mixins: [mixinMasters, MixinPermissions],

  methods: {
    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillFertilizationApplicationForm', 'secondStep');
          return res;
        })
        .then((resp) => {
          return this.validationInputsRequired('second-step');
        });
    },

    handleDelete(indexnum) {
      try {
        this.model.fertilizers.splice(indexnum, 1);
        let tmp = this.model.fertilizers;
        this.model.fertilizers = [];

        setTimeout(() => {
          this.model.fertilizers = tmp;
        }, 10);
      } catch (error) {}

      try {
        this.model.packages.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.fertilization_application_details_ids.splice(indexnum, 1);
      } catch (error) {}

      this.fertilizer_len--;
    },

    addFactor(indexnum) {
      let index = this.all_fertilizers.findIndex(
        (tableRow) => tableRow.id === this.model.fertilizers[indexnum]
      );

      if (typeof this.fertilizers_bck_ids[indexnum] !== 'undefined') {
        this.fertilizers_bck_ids.splice(indexnum, 1);
      }

      this.fertilizers_bck_ids[indexnum] = this.all_fertilizers[index].id;
    },

    getHectares() {
      this.num_hectares = localStorage.getItem('hectares');
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('fertilization/fertilizers')
        .then((response) => {
          this.all_fertilizers = response.data.data;
          this.all_fertilizers_bck = response.data.data;

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            let editForm = JSON.parse(sessionStorage.getItem('editForm'));

            this.fertilizer_len = 0;

            let tmp = [];
            editForm.fertilization_application_details.forEach((element) => {
              tmp.push(element.fertilizer_id);
              this.model.packages.push(element.number_packages);
              this.fertilizers_bck_ids.push(element.fertilizer_id);
              this.model.fertilization_application_details_ids.push(element.id);
              this.model.fertilization_application_details_ids_bck.push(
                element.id
              );
              this.fertilizer_len++;
            });

            setTimeout(() => {
              this.model.fertilizers = tmp;
            }, 10);

            this.num_hectares = editForm.hectares;

            this.model.id = editForm.id;

            this.showHideLoading();
          } else {
            this.getHectares();
            this.showHideLoading();
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
};
</script>
